export default "__VITE_ASSET__B38hmgpP__"